module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av514-af477c71f989b075b7dc2b6586b856d8.jpg";